import React, { useState, useEffect, useRef } from "react";
import { Link, useParams } from "react-router-dom";
import { MDBDataTable } from "mdbreact";
import { convertDBDate, membershipApplicationStatisticscardData } from "./common";
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import AddMembershipApplicationComponent from "./AddMembershipApplicationComponent";
import ViewMembershipApplicationComponent from "./ViewMembershipApplicationComponent";
import { baseUrl, ROUTE_BASE_URL } from "../../api/common";
import axios from "axios";
import { showToast, ToastMessage } from "../Shared/ToastMessage";
import { Pagination, InputGroup, FormControl, FormCheck } from "react-bootstrap";
import dayjs from "dayjs";
import Tooltip from '../common/toolTip';
import { useUser } from '../AdminUsers/UserContext';

const MembershipApplicationDetails = () => {

  const { slug } = useParams();
  const { checkPermission } = useUser();
  const [addPopupStatus, setAddPopupStatus] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchQuery, setSearchQuery] = useState("");
  const [eventType, setEventType] = useState("");
  const [updateId, setUpdateId] = useState("");
  const [viewPopupStatus, setViewPopupStatus] = useState(false);
  const [viewMemberId, setViewMemberId] = useState("");
  const [applicationId, setApplicationId] = useState(null);
  const [applicationName, setApplicationName] = useState("");
  const [changeStatusFormValues, setChangeStatusFormValues] = useState({
    message: "",
    password: ""
  });
  const [changeStatusErrors, setChangeStatusErrors] = useState({
    message: "",
    password: ""
  });
  const [ascdescData, setAscdescData] = useState(["New", "Old"]);
  const [ascdescFilterOpen, setAscdescFilterOpen] = useState(false);
  const [selectedAscdesc, setSelectedAscdesc] = useState("");
  const [selectedPaymentId, setSelectedPaymentId] = useState(null);
  const [applicationPaymentAmount, setApplicationPaymentAmount] = useState("");
  const [applicationPaymentDate, setApplicationPaymentDate] = useState("");
  const [applicationPaymentNarration, setApplicationPaymentNarration] = useState("");
  const [applicationStatus, setApplicationStatus] = useState("");
  const [applicationStatusId, setApplicationStatusId] = useState("");
  const [openChangeStatusModal, setOpenChangeStatusModal] = useState(false);
  const [openApproveStatusModal, setOpenApproveStatusModal] = useState(false);
  const [offlinePaymentErrors, setOfflinePaymentErrors] = useState({
    amount: "",
    date: "",
    narration: ""
  });
  const [paymentTypeData, setPaymentTypeData] = useState([]);
  const [memberDashboardData, setMemberDashboardData] = useState(null);
  const [fetchMemberDashboardStatus, setFetchMemberDashboardStatus] = useState(false);
  const [selectedTableEntry, setSelectedTableEntry] = useState(10);
  const [tableEntriesOpen, setTableEntriesOpen] = useState(false);
  const [statusFilterOpen, setStatusFilterOpen] = useState(false);
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedStatusId, setSelectedStatusId] = useState("");
  const [postGradSearch, setPostGradSearch] = useState("");
  const [superSpecialtySearch, setSuperSpecialtySearch] = useState("");
  const [stateSearch, setStateSearch] = useState("");
  const [postGradData, setPostGradData] = useState([]);
  const [superSpecialtyData, setSuperSpecialtyData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [selectedPostGrad, setSelectedPostGrad] = useState("");
  const [selectedSuperSpecialty, setSelectedSuperSpecialty] = useState("");
  const [selectedStateId, setSelectedStateId] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [postGradOpen, setPostGradOpen] = useState(false);
  const [superSpecialtyOpen, setSuperSpecialtyOpen] = useState(false);
  const [stateOpen, setStateOpen] = useState(false);
  const [postGradHighlightIndex, setPostGradHighlightIndex] = useState(-1);
  const [superSpecialtyHighlightIndex, setSuperSpecialtyHighlightIndex] = useState(-1);
  const [stateHighlightIndex, setStateHighlightIndex] = useState(-1);

  const postGradInputRef = useRef(null);
  const superSpecialtyInputRef = useRef(null);
  const stateInputRef = useRef(null);
  const postGradItemRefs = useRef([]);
  const superSpecialtyItemRefs = useRef([]);
  const stateItemRefs = useRef([]);

  const filteredPostGradData = postGradData.filter((item) =>
    item.edu_postgrad_degree.toLowerCase().includes(postGradSearch.toLowerCase())
  );
  const filteredSuperSpecialtyData = superSpecialtyData.filter((item) =>
    item.edu_superspecialty_degree.toLowerCase().includes(superSpecialtySearch.toLowerCase())
  );
  const filteredStateData = stateData.filter((item) =>
    item.name.toLowerCase().includes(stateSearch.toLowerCase())
  );

  const handleAddPopup = async(status, type, memberId) => {
    setEventType(type);
    setUpdateId(memberId);
    console.log('memberId received:', memberId);
    if(type==="Add"){
      const hasPermission = await checkPermission("Membership Application", "create");
      if (!hasPermission) return;
    }else{
      const hasPermission = await checkPermission("Membership Application", "update");
      if (!hasPermission) return;
    }
    setAddPopupStatus(status);
  };

  const handleViewMemberPopup = async(status, memberId) => {
    setViewMemberId(memberId);
    const hasPermission = await checkPermission("Membership Application", "view");
    if (!hasPermission) return;
    setViewPopupStatus(status);
  };

  function getApplicationStatusClass(type) {
    switch (type) {
      case 1:
        return "status-all-applications";
      case 2:
        return "status-pending-clarification";
      case 3:
        return "status-pending-actions";
      case 4:
        return "status-pending-resubmission";
      case 6:
        return "status-rejected";
      case 10:
        return "status-payment-status";
      case 12:
        return "status-membership-allotted";
      default:
        return "text-blue";
    }
  }
  const getApplicationPaymentStatusClass = (type) => {
    switch (type) {
      case "Pending":
        return "status-pending-clarification"
     case "Failed":
        return "status-rejected"
     case "Success":
        return "status-membership-allotted"
      default:
        return "text-blue"
    }
  }
  function convertLoginDate(notifyDate) {
    const date = dayjs.utc(notifyDate);
    const now = dayjs();

    if (now.diff(date, "days") > 0) {
      return date.format("DD MMM");
    }
    if (now.diff(date, "hours") > 0) {
      return `${now.diff(date, "hours")} hr`;
    }
    if (now.diff(date, "minutes") > 0) {
      return `${now.diff(date, "minutes")} minutes ago`;
    }
    if (now.diff(date, "seconds") > 0) {
      return `${now.diff(date, "seconds")} seconds ago`;
    }
    return "Just now";
  }
  const handleSendMail = async (memberId) => {
    try {
      console.log("Sending mail to member ID:", memberId)
      const response = await axios.post(
        `${baseUrl}/api/resend_application_no`,
        {
          id: memberId
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        })
      if (response.data.status) {
        showToast(response.data.message, "success")
      } else {
        showToast(response.data.message, "error")
      }
    } catch (error) {
      console.error("Error approving application status:", error)
    }
  }
  const [applicationMembersData, setApplicationMembersData] = useState([]);
  const membersTableData = {
    columns: [
      {
        label: "Member ID",
        field: "memberid",
        // sort: "disabled",
        attributes: { style: { width: "8%" } },
      },
      {
        label: "Name",
        field: "name",
        width: 150,
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          style: { width: "12%" },
        },
      },
      {
        label: "Application No",
        field: "application_no",
        // sort: "disabled",
        attributes: { style: { width: "8%" } },
      },
      {
        label: "Payment Status",
        field: "payment_status",
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          style: { width: "8%" },
        },
      },
      {
        label: "Mobile",
        field: "mobile",
        sort: "asc",
        attributes: { style: { width: "10%" } },
      },
      {
        label: "Email",
        field: "email",
        attributes: { style: { width: "10%" } },
      },
      {
        label: "Status",
        field: "status",
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          style: { width: "8%" },
        },
      },
      {
        label: "Application Date",
        field: "date",
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          style: { width: "10%" },
        },
      },
      {
        label: "Login Activity",
        field: "login_activity",
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          style: { width: "10%" },
        },
      },
      {
        label: "Actions",
        field: "actions",
        attributes: {
          "aria-controls": "DataTable",
          "aria-label": "Name",
          style: { width: "10%" },
        },
      }
    ],
    rows:
      applicationMembersData &&
      applicationMembersData.map((data, index) => ({
        sno: (currentPage - 1) * rowsPerPage + index + 1,
        name:data.first_name || data.middle_name || data.last_name
          ? `${data.first_name || ""} ${data.middle_name || ""} ${data.last_name || ""}`
              .trim()
              .replace(/\s+/g, " ")
          : "N/A",
        applicationid: data.application_id || "N/A",
        email: data.email || "N/A",
        mobile: data.mobile || "N/A",
        memberid: data.membership_no || "N/A",
        application_no: data.application_no || "N/A",
        status: (
          <span className={getApplicationStatusClass(data.application_status)}>
            {data.status_name || "N/A"}
          </span>
        ),
        payment_status: <span className={getApplicationPaymentStatusClass(data.payment_status)}>{data.payment_status || "N/A"}</span>,
        date: convertDBDate(data.member_reg_date) || "N/A",
        login_activity:data.last_login? convertLoginDate(data.last_login):"--",
        actions: (
          <> 
            {/* <Tooltip text="Resend mail for Application No" id={`edit-${data.id}`} /> */}
            {data.application_no?
              <button
                type="button"
                onClick={(e) =>{e.stopPropagation(); handleSendMail(data.id)}}
                className="btn btn-sm btn-default edit_button_package"
                title="Resend mail for Application No"
                data-for={`edit-${data.id}`}
                data-tip
              >
                  <i className="fa fa-envelope" />
              </button>:"--"
            }
          </> 
        ),
        clickEvent: () => handleViewMemberPopup(true, data.id),
      })),
  };
  const [tableIsLoading, setTableIsLoading] = useState(false); 
  const fetchApplicationMembersData = async (
    id = applicationId,
    status = selectedStatusId,
    limitValue = rowsPerPage,
    limitoffset = currentPage,
    searchTerm = searchQuery,
    postGraduationDegree = selectedPostGrad,
    eduSuperspecialtyDegree = selectedSuperSpecialty,
    state = selectedStateId,
    ascdesc = selectedAscdesc
  ) => {
    setTableIsLoading(true);
    try {
      const response = await axios.post(
        `${baseUrl}/api/get_member`,
        {
          application_id: id,
          application_status: status,
          limit_value: limitValue,
          limit_offset: (limitoffset - 1) * limitValue,
          search: searchTerm,
          edu_postgrad_degree: postGraduationDegree,
          edu_superspecialty_degree: eduSuperspecialtyDegree,
          state: state,
          sort_by_member_no: ascdesc==="Old"?"asc":"desc",
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      if (response.data.status) {
        setApplicationMembersData(response.data.data);
        setTotalRecords(response.data.total);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }finally{
      setTableIsLoading(false);
    }
  };

  const fetchMembershipApplicationData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/get_application`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      });
      if (response.data.status) {
        const details = response.data.data.find((item) => item.slug === slug);
        setApplicationId(details.id);
        setApplicationName(details.application_name);
        fetchApplicationMembersData(details.id);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const handleInputChange = (field, value) => {
    setChangeStatusFormValues({ ...changeStatusFormValues, [field]: value });
  };

  const validate = () => {
    const newErrors = {
      message: "",
      password: "",
    };
    if (!changeStatusFormValues.message.trim()) {
      newErrors.message = "Message cannot be empty";
    }
    // if (!changeStatusFormValues.password.trim()) {
    //   newErrors.password = "Password cannot be empty";
    // }
    setChangeStatusErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  const clearInputValues = () => {
    setChangeStatusErrors({
      message: "",
      password: "",
    });
    setChangeStatusFormValues({
      message: "",
      password: "",
    });
    handleChangeStatusModal(false, "", "");
    handleViewMemberPopup(false);
  };

  const handlePaymentIdChange = (id) => {
    setSelectedPaymentId(id);
    setApplicationPaymentAmount("");
    setApplicationPaymentDate("");
    setApplicationPaymentNarration("");
    setOfflinePaymentErrors({ amount: "", date: "", narration: "" });
  };

  const offlineValidate = () => {
    const newErrors = {
      amount: "",
      date: "",
      narration: "",
    };
    if (!applicationPaymentAmount.trim()) {
      newErrors.amount = "Amount cannot be empty";
    }
    if (!applicationPaymentDate) {
      newErrors.date = "Date cannot be empty";
    }
    if (!applicationPaymentNarration.trim()) {
      newErrors.narration = "Narration cannot be empty";
    }
    setOfflinePaymentErrors(newErrors);
    return Object.values(newErrors).every((error) => error === "");
  };

  const clearOfflineInputValues = () => {
    setOfflinePaymentErrors({
      amount: "",
      date: "",
      narration: "",
    });
    setSelectedPaymentId(null);
    setApplicationPaymentNarration("");
    setApplicationPaymentDate("");
    setApplicationPaymentAmount("");
    setOpenApproveStatusModal(false);
    handleViewMemberPopup(false);
  };

  const handleApproveStatusModal = () => {
    setOfflinePaymentErrors({
      amount: "",
      date: "",
      narration: "",
    });
    setSelectedPaymentId(null);
    setApplicationPaymentNarration("");
    setApplicationPaymentDate("");
    setApplicationPaymentAmount("");
    setOpenApproveStatusModal(false);
  };

  const handleChangeStatusModal = (status, id, applicationStatus) => {
    setApplicationStatus(applicationStatus);
    setApplicationStatusId(id);
    setOpenChangeStatusModal(status);
  };

  const handleAfterChangeStatus = () => {
    fetchMembershipApplicationData();
    clearInputValues();
  };
  const handleAscdescFilter = (status) => {
    setSelectedAscdesc(status)
  }
  const handleChangeApplicationStatus = async () => {
    if (!validate()) return;
    try {
      const response = await axios.post(
        `${baseUrl}/api/member_activity_update`,
        {
          ...changeStatusFormValues,
          member_id: viewMemberId,
          application_status: applicationStatusId,
          login_user_id: localStorage.getItem("loginUserId"),
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      if (response.data.status) {
        showToast(response.data.message, "success");
        fetchMembershipApplicationData();
        clearInputValues();
      } else {
        showToast(response.data.message, "error");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const handleApproveApplicationStatus = async () => {
    if (!selectedPaymentId) {
      showToast("Please Choose a Payment Type", "error");
      return;
    }
    if (selectedPaymentId === 2 && !offlineValidate()) {
      return;
    }
    try {
      const response = await axios.post(
        `${baseUrl}/api/create_payment_link`,
        {
          ...changeStatusFormValues,
          member_id: viewMemberId,
          application_status: applicationStatusId,
          login_user_id: localStorage.getItem("loginUserId"),
          amount: applicationPaymentAmount,
          payment_method: selectedPaymentId,
          payed_date: applicationPaymentDate,
          narration: applicationPaymentNarration,
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      if (response.data.status) {
        showToast(response.data.message, "success");
        fetchMembershipApplicationData();
        clearOfflineInputValues();
      } else {
        showToast(response.data.message, "error");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const fetchPaymentTypeData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/get_payment_method`, {
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      });
      if (response.data.status) {
        setPaymentTypeData(response.data.data);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const fetchMemberDashboardData = async (id) => {
    setFetchMemberDashboardStatus(false);
    try {
      const response = await axios.post(
        `${baseUrl}/api/member_dashboard`,
        { application_id: id },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      if (response.data.status) {
        setMemberDashboardData(response.data);
        setFetchMemberDashboardStatus(true);
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const fetchStateData = async (searchTerm = "") => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/get_state`,
        {
          id: 101,
          search: searchTerm
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      if (response.data.status) {
        setStateData(response.data.data);
      } else {
        console.error("Error: Failed to fetch state data");
      }
    } catch (error) {
      console.error("Error fetching state data:", error);
    }
  };

  const fetchPostGradData = async (searchTerm = "") => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/get_postgrad_list`,
        {
          search: searchTerm
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      if (response.data.status) {
        setPostGradData(response.data.data);
      } else {
        console.error("Error: Failed to fetch post grad data");
      }
    } catch (error) {
      console.error("Error fetching post grad data:", error);
    }
  };

  const fetchSuperSpecialtyData = async (searchTerm = "") => {
    try {
      const response = await axios.post(
        `${baseUrl}/api/get_superspecialty_list`,
        {
          search: searchTerm
        },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("access_token"),
          },
        }
      );
      if (response.data.status) {
        setSuperSpecialtyData(response.data.data);
      } else {
        console.error("Error: Failed to fetch super specialty data");
      }
    } catch (error) {
      console.error("Error fetching super specialty data:", error);
    }
  };

  const statusFilterToggle = () => setStatusFilterOpen((prevState) => !prevState);
  const tableEntriesToggle = () => setTableEntriesOpen((prevState) => !prevState);

  const handleApplicationStatusFilter = (status) => {
    setSelectedStatusId(status.id);
    setSelectedStatus(status.title);
  };

  const handlePostGradFilter = (status) => {
    setSelectedPostGrad(status.edu_postgrad_degree);
    setPostGradSearch(status.edu_postgrad_degree);
    setPostGradOpen(false);
  };

  const handleSuperSpecialtyFilter = (status) => {
    setSelectedSuperSpecialty(status.edu_superspecialty_degree);
    setSuperSpecialtySearch(status.edu_superspecialty_degree);
    setSuperSpecialtyOpen(false);
  };

  const handleStateFilter = (status) => {
    setSelectedState(status.name);
    setSelectedStateId(status.id);
    setStateSearch(status.name);
    setStateOpen(false);
  };

  const handlePostGradSearch = (searchTerm) => {
    setPostGradSearch(searchTerm);
    setPostGradHighlightIndex(-1);
  };

  const handleSuperSpecialtySearch = (searchTerm) => {
    setSuperSpecialtySearch(searchTerm);
    setSuperSpecialtyHighlightIndex(-1);
  };

  const handleStateSearch = (searchTerm) => {
    setStateSearch(searchTerm);
    setStateHighlightIndex(-1);
  };

  const handleClearFilter = () => {
    setSelectedStatusId("");
    setSelectedStatus("");
    setSelectedAscdesc("");
    setSelectedPostGrad("");
    setSelectedSuperSpecialty("");
    setSelectedState("");
    setSelectedStateId("");
    setPostGradSearch("");
    setSuperSpecialtySearch("");
    setStateSearch("");
    setPostGradData([]);
    setSuperSpecialtyData([]);
    setStateData([]);
    setPostGradHighlightIndex(-1);
    setSuperSpecialtyHighlightIndex(-1);
    setStateHighlightIndex(-1);
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const handleEntriesChange = (entries) => {
    const newLimit = Number.parseInt(entries, 10);
    setSelectedTableEntry(newLimit);
    setRowsPerPage(newLimit);
    setCurrentPage(1);
  };

  const handleSearch = (event) => {
    setSearchQuery(event.target.value);
    setCurrentPage(1);
  };

  const clearSearch = () => {
    setSearchQuery("");
  };

  const handlePostGradKeyDown = (e) => {
    if (!postGradOpen || filteredPostGradData.length === 0) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setPostGradHighlightIndex((prev) =>
        prev < filteredPostGradData.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setPostGradHighlightIndex((prev) =>
        prev > 0 ? prev - 1 : filteredPostGradData.length - 1
      );
    } else if (e.key === "Enter" && postGradHighlightIndex !== -1) {
      e.preventDefault();
      const selected = filteredPostGradData[postGradHighlightIndex];
      handlePostGradFilter(selected);
    }
  };

  const handleSuperSpecialtyKeyDown = (e) => {
    if (!superSpecialtyOpen || filteredSuperSpecialtyData.length === 0) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setSuperSpecialtyHighlightIndex((prev) =>
        prev < filteredSuperSpecialtyData.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setSuperSpecialtyHighlightIndex((prev) =>
        prev > 0 ? prev - 1 : filteredSuperSpecialtyData.length - 1
      );
    } else if (e.key === "Enter" && superSpecialtyHighlightIndex !== -1) {
      e.preventDefault();
      const selected = filteredSuperSpecialtyData[superSpecialtyHighlightIndex];
      handleSuperSpecialtyFilter(selected);
    }
  };

  const handleStateKeyDown = (e) => {
    if (!stateOpen || filteredStateData.length === 0) return;
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setStateHighlightIndex((prev) =>
        prev < filteredStateData.length - 1 ? prev + 1 : 0
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setStateHighlightIndex((prev) =>
        prev > 0 ? prev - 1 : filteredStateData.length - 1
      );
    } else if (e.key === "Enter" && stateHighlightIndex !== -1) {
      e.preventDefault();
      const selected = filteredStateData[stateHighlightIndex];
      handleStateFilter(selected);
    }
  };

  // Check Admin User Permission
  const [checkUserLoading, setCheckUserLoading] = useState(false); 
  const fetchPermission = async () => {
    setCheckUserLoading(true);
    try {
      const hasPermission = await checkPermission("Membership Application", "view");
      if (!hasPermission) return;
    } catch (error) {
      console.error("Error fetching super specialty data:", error);
    }finally{
      setCheckUserLoading(false);
    }
  };
  useEffect(() => {
    fetchPermission();
  }, []);
  
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (postGradSearch.trim() !== "") {
        fetchPostGradData(postGradSearch);
      } else {
        setPostGradData([]);
      }
    }, 300);
    return () => clearTimeout(delayDebounce);
  }, [postGradSearch]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (superSpecialtySearch.trim() !== "") {
        fetchSuperSpecialtyData(superSpecialtySearch);
      } else {
        setSuperSpecialtyData([]);
      }
    }, 300);
    return () => clearTimeout(delayDebounce);
  }, [superSpecialtySearch]);

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (stateSearch.trim() !== "") {
        fetchStateData(stateSearch);
      } else {
        setStateData([]);
      }
    }, 300);
    return () => clearTimeout(delayDebounce);
  }, [stateSearch]);

  useEffect(() => {
    if (
      postGradHighlightIndex !== -1 &&
      postGradItemRefs.current[postGradHighlightIndex] &&
      typeof postGradItemRefs.current[postGradHighlightIndex].scrollIntoView === "function"
    ) {
      postGradItemRefs.current[postGradHighlightIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [postGradHighlightIndex]);

  useEffect(() => {
    if (
      superSpecialtyHighlightIndex !== -1 &&
      superSpecialtyItemRefs.current[superSpecialtyHighlightIndex] &&
      typeof superSpecialtyItemRefs.current[superSpecialtyHighlightIndex].scrollIntoView === "function"
    ) {
      superSpecialtyItemRefs.current[superSpecialtyHighlightIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [superSpecialtyHighlightIndex]);

  useEffect(() => {
    if (
      stateHighlightIndex !== -1 &&
      stateItemRefs.current[stateHighlightIndex] &&
      typeof stateItemRefs.current[stateHighlightIndex].scrollIntoView === "function"
    ) {
      stateItemRefs.current[stateHighlightIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [stateHighlightIndex]);

  useEffect(() => {
    setPostGradHighlightIndex(-1);
  }, [postGradSearch]);

  useEffect(() => {
    setSuperSpecialtyHighlightIndex(-1);
  }, [superSpecialtySearch]);

  useEffect(() => {
    setStateHighlightIndex(-1);
  }, [stateSearch]);

  useEffect(() => {
    fetchApplicationMembersData(
      applicationId,
      selectedStatusId,
      rowsPerPage,
      currentPage,
      searchQuery,
      selectedPostGrad,
      selectedSuperSpecialty,
      selectedStateId,
      selectedAscdesc
    );
  }, [
    currentPage,
    rowsPerPage,
    searchQuery,
    selectedStatusId,
    selectedPostGrad,
    selectedSuperSpecialty,
    selectedStateId,
    applicationId,
    selectedAscdesc
  ]);

  useEffect(() => {
    fetchPaymentTypeData();
    fetchMembershipApplicationData();
  }, []);

  return (
    <>
      <ToastMessage />
      {checkUserLoading? (
        <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "500px" }}>
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
        ) : (<div className="container-fluid">
        <div className="block-header">
          <div className="row">
            <div className="col-md-7 col-sm-12">
              <h1>{applicationName}</h1>
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={`${ROUTE_BASE_URL}/`}>AMASI</Link>
                  </li>
                  <li className="breadcrumb-item">
                    <Link to={`${ROUTE_BASE_URL}/membership-application`}>Membership Application</Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    {applicationName}
                  </li>
                </ol>
              </nav>
            </div>
            <div className="col-md-5 col-sm-12 text-right hidden-xs">
              <span
                onClick={() => handleAddPopup(true, "Add", "")}
                className="btn btn-outline-primary mr-1"
              >
                Add New
              </span>
            </div>
          </div>
        </div>

        <div className="row clearfix table_scrool last_child_center">
          <div className="col-lg-12">
            <div className="card">
              <div className="body">
                <div className="row clearfix">
                  <div className="col-md-12 col-sm-12 recent-member-btns">
                    <div className="btn-default mb-2 mr-1 reports_page">
                      <Dropdown isOpen={statusFilterOpen} toggle={statusFilterToggle}>
                        <DropdownToggle caret className="btn btn-default btn-primary m-0">
                          {selectedStatus || "Filter by Status"}
                        </DropdownToggle>
                        <DropdownMenu container="body" className="custom-dropdown-menu">
                          {membershipApplicationStatisticscardData &&
                            membershipApplicationStatisticscardData
                              .filter((action) => ![13].includes(action.id))
                              .map((action) => (
                                <DropdownItem
                                  className={`${selectedStatus === action.title && "active"}`}
                                  key={action.id}
                                  onClick={() => handleApplicationStatusFilter(action)}
                                >
                                  {action.title}
                                </DropdownItem>
                              ))}
                        </DropdownMenu>
                      </Dropdown>
                    </div>
                  <div className="btn-default mb-2 mr-1 reports_page">
                    <Dropdown isOpen={ascdescFilterOpen} toggle={() => setAscdescFilterOpen(!ascdescFilterOpen)}>
                      <DropdownToggle caret className="btn btn-default btn-primary m-0">
                        {selectedAscdesc || "Filter by New/Old"}
                      </DropdownToggle>
                      <DropdownMenu container="body" className="custom-dropdown-menu">
                        {ascdescData.map((action) => (
                              <DropdownItem
                                className={`${selectedAscdesc === action && "active"}`}
                                key={action.id}
                                onClick={() => handleAscdescFilter(action)}
                              >
                                {action}
                              </DropdownItem>
                            ))}
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                    <div className="btn-default mb-2 mr-1 reports_page dropdown_select_custom" style={{ position: "relative" }}>
                      <input
                        ref={postGradInputRef}
                        type="text"
                        className="btn btn-default btn-primary m-0 custom-dropdown-menu"
                        placeholder="Filter by Post Graduation"
                        value={postGradSearch}
                        onChange={(e) => handlePostGradSearch(e.target.value)}
                        onFocus={() => setPostGradOpen(true)}
                        onBlur={() => setTimeout(() => setPostGradOpen(false), 150)}
                        onKeyDown={handlePostGradKeyDown}
                        style={{ width: "100%", boxSizing: "border-box" }}
                      />
                      {postGradSearch && (
                        <span
                          onClick={() => {
                            setPostGradSearch("");
                            setPostGradHighlightIndex(-1);
                            if (postGradInputRef.current) {
                              postGradInputRef.current.focus();
                            }
                          }}
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontWeight: "bold",
                            color: "#999",
                            zIndex: 1001,
                          }}
                        >
                          ×
                        </span>
                      )}
                      {postGradOpen && (
                        <div
                          style={{
                            position: "absolute",
                            zIndex: 1000,
                            width: "100%",
                            maxHeight: "200px",
                            overflowY: "auto",
                            border: "1px solid #ccc",
                            backgroundColor: "white",
                          }}
                        >
                          {filteredPostGradData.length === 0 ? (
                            <div className="dropdown-item" style={{ padding: "8px" }}>
                              {postGradSearch.trim() === "" ? "Start typing to search" : "No results found"}
                            </div>
                          ) : (
                            filteredPostGradData.map((action, index) => (
                              <div
                                key={action.edu_postgrad_degree}
                                ref={(el) => (postGradItemRefs.current[index] = el)}
                                className="dropdown-item"
                                style={{
                                  padding: "8px",
                                  cursor: "pointer",
                                  backgroundColor: index === postGradHighlightIndex ? "#e6f0ff" : "transparent",
                                }}
                                onMouseDown={() => {
                                  handlePostGradFilter(action);
                                }}
                              >
                                {action.edu_postgrad_degree}
                              </div>
                            ))
                          )}
                        </div>
                      )}
                    </div>

                    <div className="btn-default mb-2 mr-1 reports_page dropdown_select_custom" style={{ position: "relative" }}>
                      <input
                        ref={superSpecialtyInputRef}
                        type="text"
                        className="btn btn-default btn-primary m-0 custom-dropdown-menu"
                        placeholder="Filter by Super Specialty"
                        value={superSpecialtySearch}
                        onChange={(e) => handleSuperSpecialtySearch(e.target.value)}
                        onFocus={() => setSuperSpecialtyOpen(true)}
                        onBlur={() => setTimeout(() => setSuperSpecialtyOpen(false), 150)}
                        onKeyDown={handleSuperSpecialtyKeyDown}
                        style={{ width: "100%", boxSizing: "border-box" }}
                      />
                      {superSpecialtySearch && (
                        <span
                          onClick={() => {
                            setSuperSpecialtySearch("");
                            setSuperSpecialtyHighlightIndex(-1);
                            if (superSpecialtyInputRef.current) {
                              superSpecialtyInputRef.current.focus();
                            }
                          }}
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontWeight: "bold",
                            color: "#999",
                            zIndex: 1001,
                          }}
                        >
                          ×
                        </span>
                      )}
                      {superSpecialtyOpen && (
                        <div
                          style={{
                            position: "absolute",
                            zIndex: 1000,
                            width: "100%",
                            maxHeight: "200px",
                            overflowY: "auto",
                            border: "1px solid #ccc",
                            backgroundColor: "white",
                          }}
                        >
                          {filteredSuperSpecialtyData.length === 0 ? (
                            <div className="dropdown-item" style={{ padding: "8px" }}>
                              {superSpecialtySearch.trim() === "" ? "Start typing to search" : "No results found"}
                            </div>
                          ) : (
                            filteredSuperSpecialtyData.map((action, index) => (
                              <div
                                key={action.edu_superspecialty_degree}
                                ref={(el) => (superSpecialtyItemRefs.current[index] = el)}
                                className="dropdown-item"
                                style={{
                                  padding: "8px",
                                  cursor: "pointer",
                                  backgroundColor: index === superSpecialtyHighlightIndex ? "#e6f0ff" : "transparent",
                                }}
                                onMouseDown={() => {
                                  handleSuperSpecialtyFilter(action);
                                }}
                              >
                                {action.edu_superspecialty_degree}
                              </div>
                            ))
                          )}
                        </div>
                      )}
                    </div>

                    <div className="btn-default mb-2 mr-1 reports_page dropdown_select_custom" style={{ position: "relative" }}>
                      <input
                        ref={stateInputRef}
                        type="text"
                        className="btn btn-default btn-primary m-0 custom-dropdown-menu"
                        placeholder="Filter by State"
                        value={stateSearch}
                        onChange={(e) => handleStateSearch(e.target.value)}
                        onFocus={() => setStateOpen(true)}
                        onBlur={() => setTimeout(() => setStateOpen(false), 150)}
                        onKeyDown={handleStateKeyDown}
                        style={{ width: "100%", boxSizing: "border-box" }}
                      />
                      {stateSearch && (
                        <span
                          onClick={() => {
                            setStateSearch("");
                            setStateHighlightIndex(-1);
                            if (stateInputRef.current) {
                              stateInputRef.current.focus();
                            }
                          }}
                          style={{
                            position: "absolute",
                            right: "10px",
                            top: "50%",
                            transform: "translateY(-50%)",
                            cursor: "pointer",
                            fontWeight: "bold",
                            color: "#999",
                            zIndex: 1001,
                          }}
                        >
                          ×
                        </span>
                      )}
                      {stateOpen && (
                        <div
                          style={{
                            position: "absolute",
                            zIndex: 1000,
                            width: "100%",
                            maxHeight: "200px",
                            overflowY: "auto",
                            border: "1px solid #ccc",
                            backgroundColor: "white",
                          }}
                        >
                          {filteredStateData.length === 0 ? (
                            <div className="dropdown-item" style={{ padding: "8px" }}>
                              {stateSearch.trim() === "" ? "Start typing to search" : "No results found"}
                            </div>
                          ) : (
                            filteredStateData.map((action, index) => (
                              <div
                                key={action.id}
                                ref={(el) => (stateItemRefs.current[index] = el)}
                                className="dropdown-item"
                                style={{
                                  padding: "8px",
                                  cursor: "pointer",
                                  backgroundColor: index === stateHighlightIndex ? "#e6f0ff" : "transparent",
                                }}
                                onMouseDown={() => {
                                  handleStateFilter(action);
                                }}
                              >
                                {action.name}
                              </div>
                            ))
                          )}
                        </div>
                      )}
                    </div>

                    <button onClick={() => handleClearFilter()} className="btn btn-danger mb-2 mr-1">
                      <i className="fa fa-trash-o" aria-hidden="true" />{" "}
                      <span className="flo-txt-none">Clear Filter</span>
                    </button>
                  </div>
                </div>
                <div className="row search_entries">
                  <div className="col-md-12 col-sm-12 search_entries">
                    <div className="entries">
                      <p>Show entries: </p>
                      <div className="btn-default mb-2 ml-1">
                        <Dropdown isOpen={tableEntriesOpen} toggle={tableEntriesToggle}>
                          <DropdownToggle caret className="btn-default m-0">
                            {selectedTableEntry}
                          </DropdownToggle>
                          <DropdownMenu container="body" className="custom-dropdown-menu">
                            {[5, 10, 20, 50].map((option) => (
                              <DropdownItem key={option} onClick={() => handleEntriesChange(option)}>
                                {option}
                              </DropdownItem>
                            ))}
                          </DropdownMenu>
                        </Dropdown>
                      </div>
                    </div>
                    <div>
                      <InputGroup className="mb-3" style={{ position: "relative" }}>
                        <FormControl placeholder="Search ..." value={searchQuery} onChange={handleSearch} />
                        {searchQuery && (
                          <span className="clear-icon" onClick={clearSearch}>
                            <i className="fa fa-times-circle" aria-hidden="true" />
                          </span>
                        )}
                      </InputGroup>
                    </div>
                  </div>
                </div>
              <div className="table-responsive">
                {tableIsLoading ? (
                  <div className="d-flex justify-content-center align-items-center" style={{ minHeight: "200px" }}>
                    <div className="spinner-border text-primary" role="status">
                      <span className="sr-only">Loading...</span>
                    </div>
                  </div>
                ) : (
                <>  
                <MDBDataTable
                  noBottomColumns
                  className="table table-hover js-basic-example dataTable table-custom spacing5 check-box-custom"
                  entries={rowsPerPage}
                  data={membersTableData}
                  sortRows={["title"]}
                  paging={false}
                  searching={false}
                />
                <Pagination className="justify-content-center">
                  <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 1}>
                    Previous
                  </Pagination.Prev>
                  {(() => {
                    const totalPages = Math.ceil(totalRecords / rowsPerPage)
                    const maxPagesToShow = 5
                    let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2))
                    let endPage = startPage + maxPagesToShow - 1
                    if (endPage > totalPages) {
                      endPage = totalPages
                      startPage = Math.max(1, endPage - maxPagesToShow + 1)
                    }
                    return [...Array(endPage - startPage + 1)].map((_, index) => {
                      const pageNumber = startPage + index
                      return (
                        <Pagination.Item
                          key={pageNumber}
                          active={pageNumber === currentPage}
                          onClick={() => handlePageChange(pageNumber)}
                        >
                          {pageNumber}
                        </Pagination.Item>
                      )
                    })
                  })()}
                  <Pagination.Next
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === Math.ceil(totalRecords / rowsPerPage)}
                  >
                    Next
                  </Pagination.Next>
                </Pagination></>)}
              </div>
              </div>
            </div>
          </div>
        </div>

        <AddMembershipApplicationComponent
          memberId={updateId}
          eventType={eventType}
          fetchApplicationMembersData={fetchApplicationMembersData}
          memberApplicationId={applicationId}
          addPopupStatus={addPopupStatus}
          handleAddPopup={handleAddPopup}
        />

        <ViewMembershipApplicationComponent
          handleAfterChangeStatus={handleAfterChangeStatus}
          handleChangeStatusModal={handleChangeStatusModal}
          applicationName={applicationName}
          fetchApplicationMembersData={fetchApplicationMembersData}
          memberId={viewMemberId}
          viewPopupStatus={viewPopupStatus}
          handleAddPopup={handleAddPopup}
          handleViewMemberPopup={handleViewMemberPopup}
        />

        {openChangeStatusModal && (
          <div className="modal fade d-block show">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Change Status</h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => handleChangeStatusModal(false, "", "")}
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="d-flex mb-3">
                    <div>
                      <h6 className="mb-0">
                        Would you like to change the application status to "{applicationStatus}"?
                      </h6>
                    </div>
                  </div>
                  {/* <div className="form-group pos_relative">
                    <label>Enter Your Password</label>
                    <input
                      type="password"
                      className={`form-control ${changeStatusErrors.password ? "red_border" : ""}`}
                      value={changeStatusFormValues.password}
                      onChange={(e) => handleInputChange("password", e.target.value)}
                    />
                    {changeStatusErrors.password && (
                      <p className="text-danger pos_abos">{changeStatusErrors.password}</p>
                    )}
                  </div> */}
                  <div className="form-group pos_relative">
                    <label>Message</label>
                    <textarea
                      rows={4}
                      className={`form-control ${changeStatusErrors.message ? "red_border" : ""}`}
                      value={changeStatusFormValues.message}
                      onChange={(e) => handleInputChange("message", e.target.value)}
                    />
                    {changeStatusErrors.message && (
                      <p className="text-danger pos_abos">{changeStatusErrors.message}</p>
                    )}
                  </div>
                </div>
                <div className="modal-footer">
                  <button
                    type="button"
                    className="btn btn-default"
                    onClick={() => handleChangeStatusModal(false, "", "")}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-success"
                    onClick={handleChangeApplicationStatus}
                  >
                    Proceed
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}

        {openApproveStatusModal && (
          <div className="modal fade d-block show">
            <div className="modal-dialog" role="document">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Confirm Change Status</h5>
                  <button
                    type="button"
                    className="close"
                    onClick={() => handleApproveStatusModal()}
                    aria-label="Close"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body">
                  <div className="d-flex mb-3">
                    <div>
                      <h6 className="mb-0">Choose a Payment Type</h6>
                    </div>
                  </div>
                  <div className="form-group pos_relative">
                    <div className="col-lg-12 col-md-12">
                      <div className="check_grid">
                        {paymentTypeData.map((data) => (
                          <div key={data.id}>
                            <FormCheck
                              type="checkbox"
                              id={`checkbox-${data.id}`}
                              label={data.payment_name}
                              checked={selectedPaymentId === data.id}
                              onChange={() => handlePaymentIdChange(data.id)}
                            />
                          </div>
                        ))}
                      </div>
                      {selectedPaymentId === 2 && (
                        <div className="col-lg-12 col-md-12">
                          <div className="row pt-4">
                            <div className="col-lg-4 col-md-4 p-i-0 pos_relative">
                              <input
                                type="number"
                                className={`form-control ${offlinePaymentErrors.amount ? "red_border" : ""}`}
                                placeholder="Amount Paid"
                                value={applicationPaymentAmount}
                                onChange={(e) => setApplicationPaymentAmount(e.target.value)}
                              />
                              {offlinePaymentErrors.amount && (
                                <p className="text-danger pos_abos white_space">{offlinePaymentErrors.amount}</p>
                              )}
                            </div>
                            <div className="col-lg-4 col-md-4 p-i-0 pos_relative">
                              <input
                                type="date"
                                className={`form-control ${offlinePaymentErrors.date ? "red_border" : ""}`}
                                onClick={(e) => e.target.showPicker()}
                                placeholder="Date"
                                value={applicationPaymentDate}
                                onChange={(e) => setApplicationPaymentDate(e.target.value)}
                              />
                              {offlinePaymentErrors.date && (
                                <p className="text-danger pos_abos">{offlinePaymentErrors.date}</p>
                              )}
                            </div>
                            <div className="col-lg-4 col-md-4 p-i-0">
                              <div className="form-group pos_relative">
                                <input
                                  type="text"
                                  className={`form-control ${offlinePaymentErrors.narration ? "red_border" : ""}`}
                                  placeholder="Narration"
                                  value={applicationPaymentNarration}
                                  onChange={(e) => setApplicationPaymentNarration(e.target.value)}
                                />
                                {offlinePaymentErrors.narration && (
                                  <p className="text-danger pos_abos">{offlinePaymentErrors.narration}</p>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="modal-footer">
                  <button type="button" className="btn btn-default" onClick={() => handleApproveStatusModal()}>
                    Cancel
                  </button>
                  <button type="button" className="btn btn-danger" onClick={handleApproveApplicationStatus}>
                    Proceed
                  </button>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>)}
    </>
  );
};

export default MembershipApplicationDetails;